import Cookies from 'js-cookie';
import _storage from '@/js/storage';

const TokenKey = 'USER-Token'
const LocalToken = 'USER_ACTOKEN'


export function getToken() {
  //console.log('Cookies token ',Cookies.get(TokenKey));
  //console.log('_storage token ',_storage.sessionGet(LocalToken));
  return Cookies.get(TokenKey) || _storage.sessionGet(LocalToken);
}

export function setToken(token) {
  console.log('auth setToken',token)
  _storage.sessionSet(LocalToken,token);
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  console.log("removeToken is done");
  _storage.sessionDel(LocalToken)
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js